import * as React from "react";
import { useTranslation } from "react-i18next";
import Panel from "../../Panel/Panel";
import styled from "styled-components";
import Editor, { MINIMAL_EDITOR_CONFIG, NOTES_EDITOR_CONFIG } from "../../Editor/Editor";
import LocalStorage, { LocalStorageKey } from "../../../LocalStorage";

const Container = styled.div`
  height: 100%;
`

// Stretches the editor over the whole panel: the text area grows with the panel and the toolbar stays at the bottom
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100% + 32px);
  margin: -16px;

  .dashboard-mobile & {
    min-height: 200px;
  }

  > div, .fr-box {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
  }

  .fr-wrapper {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    border: none !important;
  }

  .fr-element {
    min-height: 100%;
  }

  .fr-toolbar, .fr-second-toolbar {
    flex-shrink: 0;
  }

  .fr-toolbar {
    border: none !important;
  }
`

interface IProps { }

const MemoWidget = (props: IProps) => {
  const { t } = useTranslation();

  const [model, setModel] = React.useState<string>(LocalStorage.get(LocalStorageKey.DASHBOARD_MEMO, ''));

  const onModelChange = (model: string) => {
    setModel(model)
    LocalStorage.set(LocalStorageKey.DASHBOARD_MEMO, model)
  }

  return (
    <Container>
      <Panel className="h-full flex flex-col mb-0!" contentClasses="min-h-0 flex-1 overflow-auto" title={t('MemoWidget::Memo')}>
        <Wrapper>
          <Editor
            model={model}
            onModelChange={onModelChange}
            config={{
              ...MINIMAL_EDITOR_CONFIG,
              placeholderText: t('MemoWidget::Add notes (only visible for you)'),
              toolbarBottom: true
            }}
          />
        </Wrapper>
      </Panel>
    </Container>
  )
}

export default MemoWidget